// extracted by mini-css-extract-plugin
module.exports = {"container":"banner_container__gJ_qv","size0":"banner_size0__u5vbS","dev":"banner_dev__p9qYl","size300_600":"banner_size300_600__31y6v"};